import clsx from 'clsx'
import React from 'react'

import {useFeedbackReasons} from '../../hooks'
import ComplimentReason from './ComplimentReason'
import {classes} from './FeedbackDetails.styles'
import TagReason from './TagReason'

type Props = {
  score: number
  selected?: string[]
  onChange: Function
  visible?: boolean
}

const FeedbackDetails: React.FC<Props> = ({onChange, score, selected = [], visible = true}) => {
  const reasons = useFeedbackReasons(score)
  const isCompliment = score === 5
  const ReasonComponent = isCompliment ? ComplimentReason : TagReason

  if (reasons.length === 0) {
    return null
  }

  return (
    <div className={clsx(visible ? classes.visible : classes.hidden)}>
      <div className={clsx(classes.root, isCompliment && classes.complimentContainer)}>
        {reasons.map(reason => (
          <ReasonComponent
            data={reason}
            key={reason.reason_id}
            onClick={onChange}
            selected={selected.includes(reason.reason_id)}
          />
        ))}
      </div>
    </div>
  )
}

export default FeedbackDetails
